export default "__VITE_ASSET__GvkuCDZu__"